import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuthReadiness } from "./useAuthReadiness";

export const useHasUserReviewed = (productId: string) => {
  const { user, canQueryUserData } = useAuthReadiness();

  return useQuery({
    queryKey: ["has-reviewed", productId, user?.id],
    queryFn: async () => {
      if (!user?.id) return false;

      const { data, error } = await supabase
        .from("product_reviews")
        .select("id")
        .eq("product_id", productId)
        .eq("user_id", user.id)
        .maybeSingle();

      if (error) throw error;
      return !!data;
    },
    enabled: canQueryUserData && !!productId,
  });
};
